module.exports = __webpack_public_path__ + "static/how-it-works-3f3aa41ece918869adf5efc9b1cc855e.png";